// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOGS_ADD_NEW_COMMENT_PLACEHOLDER = "Za\u010dni ps\u00e1t koment\u00e1\u0159...";
export const SEND_COMMENT_FORUM = "Ode\u0161li";
